
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class BooksDialog extends Serenity.EntityDialog<BooksRow, any> {
        protected getFormKey() { return BooksForm.formKey; }
        protected getIdProperty() { return BooksRow.idProperty; }
        protected getLocalTextPrefix() { return BooksRow.localTextPrefix; }
        protected getNameProperty() { return BooksRow.nameProperty; }
        protected getService() { return BooksService.baseUrl; }
        protected getDeletePermission() { return BooksRow.deletePermission; }
        protected getInsertPermission() { return BooksRow.insertPermission; }
        protected getUpdatePermission() { return BooksRow.updatePermission; }

        protected form = new BooksForm(this.idPrefix);

    }
}